import React from 'react'
import BaseTextField from '@/v2/components/common/TextField'
import BaseRadioField from '@/v2/components/common/RadioField'
import BaseDateOfBirthInput from '@/v2/components/common/DateOfBirthInput'
import { RequiredMark } from './styles'

// The sections mark a required field by ending its label with " *". All three
// inputs below render the label through the shared FieldLabel, which accepts a
// node, so we can split that trailing asterisk out and colour it red in one
// place instead of hand-building JSX at every call site.
//
// The label's text content is left identical ("Email *") — only its markup
// changes. Labels that are not strings, or that carry no marker, pass straight
// through.
export const markRequired = label => {
  if (typeof label !== 'string' || !label.endsWith(' *')) return label

  return (
    <>
      {label.slice(0, -2)} <RequiredMark>*</RequiredMark>
    </>
  )
}

// A failed submit scrolls to the first element carrying this attribute. Every
// field already receives its own `error`, so each one can mark itself and
// document order picks the winner — no field-name registry to keep in sync
// with the section layout.
export const INVALID_ATTR = 'data-hhf-invalid'

// Rendered unconditionally so toggling an error never remounts the input and
// steals focus; only the attribute comes and goes.
const Anchor = ({ error, children }) => (
  <div {...(error ? { [INVALID_ATTR]: '' } : {})}>{children}</div>
)

export const TextField = ({ label, ...props }) => (
  <Anchor error={props.error}>
    <BaseTextField label={markRequired(label)} {...props} />
  </Anchor>
)

// The base RadioField forwards a ref; keep that intact through the wrapper.
export const RadioField = React.forwardRef(({ label, ...props }, ref) => (
  <Anchor error={props.error}>
    <BaseRadioField ref={ref} label={markRequired(label)} {...props} />
  </Anchor>
))

RadioField.displayName = 'RadioField'

export const DateOfBirthInput = ({ label, ...props }) => (
  <Anchor error={props.error}>
    <BaseDateOfBirthInput label={markRequired(label)} {...props} />
  </Anchor>
)
